import QUEUE from '@/setting/layout/pre-origination/queue/queue'
import ITEM from '@/setting/layout/pre-origination/queue/item'

export const LOS_QUEUE_LAYOUT_SETTING = {
  QUEUE,
  ITEM
}
